import React from "react"

import LayoutHeaderMenu from "../LayoutHeaderMenu/LayoutHeaderMenu"
import Monitor from "../Monitor/Monitor"

import "./masterData.scss"

const MasterData = (props) => {
  const uri = props.uri.split("/")

  const {
    set_metadata,
    text_header_title,
    text_header_description,
    asset_header_picture,
    asset_logo,
    text_title,
    wysiwyg_description,
    arr_functions_cards,
  } = props.pageContext.content.product_modules_masterdata
  const siteMetadata = {
    title: set_metadata.text_page_title,
    description: set_metadata.text_page_description,
    meta: [
      {
        name: "keywords",
        content: set_metadata.text_keywords,
      },
    ],
    author: `prodHost`,
  }

  return (
    <div className="masterdata-wrapper">
      <LayoutHeaderMenu
        siteMetadata={siteMetadata}
        header_logo={
          props.pageContext.content.global_values.set_logos
            .asset_prodhost_logo_white_120p
        }
        header_title={text_header_title}
        header_description={text_header_description}
        header_background={
          asset_header_picture
            ? `${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${asset_header_picture.path}`
            : ""
        }
        header_shaded
        menu={props.pageContext.menu.entries}
        color={"white"}
        selected={`${uri[1]}`}
        selected2={`${uri[1]}_${uri[2]}`}
        selected3={`${uri[1]}_${uri[2]}_${uri[3]}`}
        expanded
        footer={props.pageContext.content.global_values.set_footer}
      >
        <div className="layout-industries-head">
          <div className="image-wrapper">
            <img
              src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${asset_logo.path}`}
              alt=""
            />
          </div>
          <div className="layout-industries-title">
            <h1>{text_title}</h1>
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: wysiwyg_description }}
            ></div>
          </div>
        </div>
        {arr_functions_cards.map((card, index) => {
          return props.pageContext.content.apiVideoData.data.map(
            (item, index2) => {
              if (
                item.description &&
                item.description.includes(card.value.text_function_video_url)
              ) {
                return (
                  <div
                    key={`${index2}`}
                    className={
                      index % 2 === 0 ? "card-item" : "card-item reverse"
                    }
                  >
                    {item.assets.iframe ? (
                      <div className="image-wrapper">
                        <Monitor
                          monitor={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${card.value.asset_function_picture.path}`}
                          content={item.assets}
                          uri={props.uri}
                          index={index}
                        />
                      </div>
                    ) : null}

                    <div className="content-wrapper">
                      <h2 className="content-title">
                        {card.value.text_function_title}
                      </h2>
                      <div
                        className="content-body"
                        dangerouslySetInnerHTML={{
                          __html: card.value.wysiwyg_function_description,
                        }}
                      ></div>
                    </div>
                  </div>
                )
              }
            }
          )
        })}
      </LayoutHeaderMenu>
    </div>
  )
}

export default MasterData
